import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from "react";
import EditIcon from "@mui/icons-material/Edit";
import { CustomIcon, CustomText, WrapperContainer, } from "@corporate-trip-planner-fe/ui-styles";
import { formFieldRenderer } from "@corporate-trip-planner-fe/ui-components";
import { getIn } from "formik";
export var InlineEditField = function (_a) {
    var fieldConfig = _a.fieldConfig, formik = _a.formik, value = _a.value, onSave = _a.onSave, label = _a.label, _b = _a.placeholder, placeholder = _b === void 0 ? "Enter value" : _b, _c = _a.className, className = _c === void 0 ? "" : _c, currentEditField = _a.currentEditField, setcurrentEditField = _a.setcurrentEditField, whiteSpace = _a.whiteSpace, customRenderField = _a.customRenderField;
    var wrapperRef = useRef(null);
    var fieldName = fieldConfig.name;
    var formikInputValue = getIn(formik.values, fieldName);
    var handleSave = function () {
        setcurrentEditField("");
    };
    var handleKeyDown = function (e) {
        var isMultiline = fieldConfig.type === "textarea" ||
            fieldConfig.component === "textarea" ||
            fieldConfig.multiline;
        console.log("isMultiline: ", isMultiline, e.shiftKey, !(isMultiline && e.shiftKey));
        if (e.key === "Enter" && !(isMultiline && e.shiftKey)) {
            e.preventDefault();
            handleSave();
        }
        else if (e.key === "Escape") {
            handleSave();
        }
    };
    var renderReadOnlyView = function () {
        if (customRenderField) {
            return customRenderField;
        }
        return (_jsxs(_Fragment, { children: [formikInputValue || placeholder, _jsx(CustomIcon, { "$color": fieldConfig.color || "black", "$fontSize": "1rem", children: _jsx(EditIcon, {}) })] }));
    };
    return (_jsxs(WrapperContainer, { ref: wrapperRef, onKeyDown: handleKeyDown, "$padding": "0", children: [label && _jsxs("label", { className: "font-medium text-gray-600", children: [label, ":"] }), currentEditField !== fieldConfig.name ? (_jsx(CustomText, { "$cursor": "pointer", "$color": fieldConfig.color || "black", onClick: function () { return setcurrentEditField(fieldName); }, "$justifyContent": "space-between", "$whiteSpace": whiteSpace || "pre", "$textAlign": "justify", children: renderReadOnlyView() })) : (_jsx(WrapperContainer, { "$backgroundColor": "white", "$borderRadius": "8px", "$padding": "0", children: formFieldRenderer(fieldConfig, formik) }))] }));
};
